import { createRoutine } from 'redux-saga-routines';
import type { FetchUserBillingPayload } from './interfaces';
import type { Coupon } from '@simplywallst/services/lib/endpoints/getCoupon';
import type { Response as GetUserResponse } from '@simplywallst/services/lib/endpoints/getUser';
import type { UserAccess as UacCheckResponse } from '@simplywallst/services/lib/endpoints/getUacCheck';

/**
 * Access
 */

export const fetchUserAccess = createRoutine<
  SimplePayloadCreator, // trigger
  SimplePayloadCreator, // request
  SimplePayloadCreator<{ data: UacCheckResponse }>, //success
  SimplePayloadCreator<string>, // failure
  SimplePayloadCreator // fulfill
>('@USER/ACCESS_FETCH', {});

export const fetchUserBilling = createRoutine<
  FetchUserBillingPayload['trigger'],
  FetchUserBillingPayload['request'],
  FetchUserBillingPayload['success'],
  FetchUserBillingPayload['failure'],
  FetchUserBillingPayload['fulfill']
>('@USER/BILLING_FETCH', {});

/**
 * Profile
 */

export const fetchUserProfile = createRoutine<
  SimplePayloadCreator, // trigger
  SimplePayloadCreator, // request
  SimplePayloadCreator<GetUserResponse>, //success
  SimplePayloadCreator<string>, // failure
  SimplePayloadCreator // fulfill
>('@USER/PROFILE_FETCH', {});

export interface UpdateUserProfileTrigger {
  email?: string;
  givenName?: string;
  familyName?: string;
  password?: string;
  passwordConfirm?: string;
  settings?: {
    defaultMarket?: string;
    feedSorting?: string;
    showLiquidated?: boolean;
    holdingsSorting?: string;
    defaultPortfolio?: string;
    hasSeenSAModal?: boolean;
    hasSeenSubscriptionModal?: boolean;
    hasSeenTrialEndModal?: boolean;
  };
}

export const updateUserProfile = createRoutine<
  SimplePayloadCreator<UpdateUserProfileTrigger>, // trigger
  SimplePayloadCreator, // request
  SimplePayloadCreator, //success
  SimplePayloadCreator<string>, // failure
  SimplePayloadCreator // fulfill
>('@USER/PROFILE_UPDATE', {});

// Hydrate user profile from 'getUser' request (external to redux)
export const hydrateUserProfile = createRoutine<
  SimplePayloadCreator<GetUserResponse>, // trigger
  never, // request
  SimplePayloadCreator<GetUserResponse>, //success
  SimplePayloadCreator<string>, // failure
  never // fulfill
>('@USER/PROFILE_HYDRATE', {});

export const updateCoupon = createRoutine<
  SimplePayloadCreator<string>, // trigger
  SimplePayloadCreator, // request
  SimplePayloadCreator<Coupon>, //success
  SimplePayloadCreator<string>, // failure
  SimplePayloadCreator // fulfill
>('@USER/UPDATE_COUPON', {});
